import React from "react";
import {
  InlineTypeahead,
  InlineTypeaheadProps,
} from "~/components/inline-typeahead";
import {
  ServiceDescription,
  useServiceDescriptionsAsync,
} from "~/refdata2/serviceDescriptions";
import "./InlineServiceDescriptionPicker.scss";
import _ from "lodash";
import {
  createSearchRegex,
  TextHighlighter,
} from "~/components/text-highlighter";

const formatSuggestion = (
  item: ServiceDescription,
  searchText: string
): React.ReactNode => {
  const searchRegex = createSearchRegex(searchText);

  return (
    <div className="service-description-picker-menuitem">
      <TextHighlighter text={item.displayName} search={searchRegex} />
    </div>
  );
};
const format = (item: ServiceDescription): React.ReactNode => item.displayName;

type InlineServiceDescriptionPickerProps = {
  name: string;
  value: ServiceDescription;
  onChange: (val: ServiceDescription | null) => void;
  onBlur?: React.FocusEventHandler<any>;
  submitError?: string;
  required?: boolean;
};

export const InlineServiceDescriptionPicker: React.FC<
  InlineServiceDescriptionPickerProps
> = (props) => {
  const getServiceDescriptions = useServiceDescriptionsAsync();

  const getData = async (searchText: string) => {
    const unorderedResult = ((await getServiceDescriptions()) ?? []).filter(
      (x) => x.isActive
    );
    const result = _.orderBy(unorderedResult, [
      (x) => x.industry,
      (x) => x.projectType,
      (x) => x.description,
    ]);

    if (!searchText) {
      return result;
    }

    return result.filter((t) =>
      t.displayName.toLowerCase().includes(searchText.toLowerCase())
    );
  };

  const args = {
    ...props,
    getData,
    format,
    formatSuggestion,
  } as InlineTypeaheadProps<ServiceDescription>;

  return (
    <div className="inline-service-description-picker">
      <InlineTypeahead {...args} />
    </div>
  );
};
